import SliderPanel from "./SliderPanel";

export default SliderPanel;
